import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//

import sellerDetail from '~/components/collaborators/seller-detail';
import { ConflictError } from '~/abstractions/errors';

export default {
    components: {
        sellerDetail: sellerDetail
    },
    data: function data() {
        return {
            data: Number(this.$route.params.id)
        };
    },
    fetch: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                query = _ref.query,
                redirect = _ref.redirect,
                app = _ref.app,
                params = _ref.params;
            var value, response, valueId;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            value = Number(params.idSeller);
                            _context.next = 4;
                            return store.dispatch('team/findSellerById', value);

                        case 4:
                            response = _context.sent;
                            _context.next = 10;
                            break;

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](0);

                            if (_context.t0 instanceof ConflictError) {
                                valueId = Number(params.id);

                                redirect('/channels/teams/' + valueId);
                            } else app.$controlMessage(_context.t0);

                        case 10:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 7]]);
        }));

        function fetch(_x) {
            return _ref2.apply(this, arguments);
        }

        return fetch;
    }(),
    asyncData: function asyncData(_ref3) {
        var app = _ref3.app,
            redirect = _ref3.redirect;

        if (app.$isAdmin()) {
            return redirect('/bosses');
        } else if (app.$isSupervisor()) {
            return redirect('/my-team');
        }
        return null;
    },
    mounted: function mounted() {
        Number(this.$route.params.id);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/channels/teams/_id/sellers/_idSeller.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/channels/teams/_id/sellers/_idSeller.vue
// module chunks = 11